import type * as ents from '@attain-apps/entities'

/** Request and upload-file state for knowledge-base document management. */
export interface State {
  readonly fileInputVersion: number
  readonly inventory: Entry<ents.core.agent.KnowledgeBase.Management>
  readonly selectedFile: Entry<File> | undefined
  readonly tenants: Entry<readonly ents.core.admin.Tenant[]>
  readonly zones: ZoneRequest | undefined
}

/** Data, loading, or failure state for a management value. */
type Entry<TData> = ExactlyOneOf<{
  readonly data: TData
  readonly loading: true
  readonly error: Error
}>

/** Zone request state correlated to the tenant for which it was loaded. */
interface ZoneRequest {
  readonly entry: Entry<readonly ents.core.admin.Zone[]>
  readonly tenantId: ents.core.admin.Tenant.Id
}

export namespace State {
  /** Initial management state before inventory and tenants are loaded. */
  export const INITIAL: State = {
    fileInputVersion: 0,
    inventory: { loading: true },
    selectedFile: undefined,
    tenants: { loading: true },
    zones: undefined,
  }
}
